module.exports = __webpack_public_path__ + "img/bicycle-crossing.ab4b9580.jpg";